module.exports = __webpack_public_path__ + "img/frame.1b10b992.svg";